<template>
  <div id="app" class="w-full overflow-hidden">
    <LoadingOverlay :active="isLoading" />
    <router-view></router-view>
  </div>
</template>
<script>
  import { computed } from 'vue'
  import { useStore } from 'vuex'
  import LoadingOverlay from '@/components/modules/LoadingOverlay.vue'

  export default {
    components: {
      LoadingOverlay
    },
    setup () {
      const store = useStore()
      const isLoading = computed(() => store.getters['isLoading'])

      return {
        isLoading
      }
    }
  }
  </script>
<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>
